import styled from 'styled-components';

export const FilterStatusList = styled.div`
  display: flex;
  flex-direction: row;
`;
